import { awsPartitionFromUse } from "@p0security/integrations-aws-shared/gov-cloud";
import {
  iamWriteInstallCommands,
  iamWriteTerraform,
} from "@p0security/integrations-aws-shared/policy/iam-write";
import { Typography } from "@p0security/ui";

import type { AwsInstaller } from "../types";
import { loginInstaller } from "./login";

const FEATURE_FLAG_LEAST_PRIVILEGE_AWS_P0_IAM_MANAGER =
  "leastPrivilegeAwsP0IamManagerRoleSshOnly";

const FEATURE_FLAG_TAG_IDC_PERMISSION_SETS = "tagIdcPermissionSets";

const iamWriteInstructions: AwsInstaller["components"]["iam-write"]["instructions"] =
  (context, id) => {
    const awsPolicyOptions = {
      sshOnly: context.featureFlags?.[
        FEATURE_FLAG_LEAST_PRIVILEGE_AWS_P0_IAM_MANAGER
      ] as boolean,
      tagPermissionSets: context.featureFlags?.[
        FEATURE_FLAG_TAG_IDC_PERMISSION_SETS
      ] as boolean,
    };
    const serviceAccountId = context.config.base[id]?.serviceAccountId;
    const awsPartition = awsPartitionFromUse(context.config, id, "iam-write");
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using{" "}
          <Typography.Link
            href={`https://${id}.signin.aws.amazon.com/console`}
            target="_blank"
            rel="noopener"
          >
            AWS Cloud Shell
          </Typography.Link>{" "}
          or Terraform:
        </>
      ),
      commands: {
        shell: [
          {
            command: iamWriteInstallCommands(context, awsPolicyOptions, {
              gcloudServiceAccountId: serviceAccountId,
              awsAccountId: id,
              awsPartition,
            }),
          },
        ],
        iac: [
          {
            command: iamWriteTerraform(
              serviceAccountId,
              context,
              awsPolicyOptions,
              awsPartition
            ),
          },
        ],
      },
    };
  };

export const awsIamWriteInstaller: AwsInstaller["components"]["iam-write"] = {
  instructions: iamWriteInstructions,
  items: {
    login: loginInstaller,
  },
};
